import React from 'react'
import {Box} from '@mui/material'
import ThemeProviderNew from 'src/theme-new/ThemeProviderNew'
import {APP_BACKGROUND} from 'src/theme-new/tokens'
import ChangePortalHeaderNew from './ChangePortalHeaderNew'
import ChangePortalNew from './ChangePortalNew'

// Standalone page (no AppShellNew / sidebar), routed at the top level in
// MainRouting.tsx alongside the legacy ChangePortalPage — matches legacy's
// "no lateral menu" behaviour for the portal-switch screen.
export default function ChangePortalPageNew(): JSX.Element {
  return (
    <ThemeProviderNew>
      <Box sx={{minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: APP_BACKGROUND}}>
        <ChangePortalHeaderNew />
        <Box sx={{flex: 1, px: {xs: 2, md: 4}, py: 4}}>
          <ChangePortalNew />
        </Box>
      </Box>
    </ThemeProviderNew>
  )
}
